import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { alpha } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import { useRouter } from 'src/routes/hooks';

import useAxios from 'src/hooks/use-axios';
import { useAuth } from 'src/hooks/use-auth';
import { useDoctor } from 'src/hooks/use-doctor';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const { t } = useTranslation();
  const { doctor } = useDoctor();
  const { setAuth } = useAuth();
  const router = useRouter();
  const api = useAxios();

  const MENU_OPTIONS = [
    {
      label: t('login.instructions'),
      handleClick: () => {
        // router.push('/instructions/staff');
        window.open('https://megi-my.s3.amazonaws.com/static/common/certificates/ifu_staff.pdf', '_blank');
        handleClose();
      },
    },
    {
      label: t('login.about_us'),
      handleClick: () => {
        router.push('/instructions/staff/about');
        handleClose();
      },
    },
  ];

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    api
      .post('auth/logout/')
      .then(() => {
        setAuth(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          alt={doctor?.displayName}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {doctor?.email?.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 200,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {doctor?.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {doctor?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed', m: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem key={option.label} onClick={option.handleClick} sx={{ py: 1 }}>
            {option.label}
          </MenuItem>
        ))}

        <Divider sx={{ borderStyle: 'dashed', m: 1 }} />

        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={handleLogout}
          sx={{ typography: 'body2', color: 'error.main', py: 1 }}
        >
          {t('login.logout')}
        </MenuItem>
      </Popover>
    </>
  );
}
